import React from 'react';

import sgtfBox from './sgtf-box.png';
import popupCloseBtn from './popup-close.png';
import './InvitePopup.css';

const InvitePopup = ({ closeInvitePopup }) => {
  const goToInviteFriends = () => window.location.assign(process.env.REACT_APP_INVITE_FRIENDS_URL);
  return (
    <div>
      <div
        className="invite-popup-overlay"
        role="button"
        aria-label="Close"
        tabIndex={0}
        onClick={closeInvitePopup}
        onKeyPress={closeInvitePopup}
      />
      <div className="invite-popup-container">
        <div className="invite-popup">
          <div
            className="invite-popup__close"
            role="button"
            tabIndex={0}
            onClick={closeInvitePopup}
            onKeyPress={closeInvitePopup}
          >
            <img src={popupCloseBtn} alt="" />
          </div>
          <div className="invite-popup__info">
            <span className="invite-popup__info__title--small">Show them you care</span>
            <h2 className="invite-popup__info__title">Share FabFitFun for FREE!</h2>
            <p className="invite-popup__info__title--msg">
              Gift your loved ones a little surprise at their door this season.
              Send a Starter Box to friends and family that haven’t tried FabFitFun yet
              (they’ll just pay for shipping).
            </p>
            <button
              className="invite-popup__info__button"
              type="button"
              onClick={goToInviteFriends}
            >
              Send Boxes Now
            </button>
          </div>
          <div className="invite-popup__box">
            <img src={sgtfBox} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitePopup;
